import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { connect } from 'react-redux'
import { fetchIdeas } from '../../store/actions/ideas'
import IdeaSummaryCard from '../common/idea-summary-card'
import Loading from '../common/loading'
import { getAvailableTagsList } from '../../store/actions/tags'
import { isIdeaWellFormed } from '../../misc/utils'
import { Link } from 'react-router-dom'

export class IdeaExplorerView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            filters: {
                search: undefined,
                tag: undefined,
                status: undefined,
                filter_by: undefined,
                filter_value: undefined,
                sort: undefined,
                asc: undefined,
            },
        }
    }

    componentDidMount() {
        this.props.fetchIdeas()
        this.props.getAvailableTagsList()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.filters !== this.state.filters) {
            this.props.fetchIdeas(
                undefined,
                undefined,
                this.state.filters.sort,
                this.state.filters.asc,
                this.state.filters.search,
                this.state.filters.filter_by,
                this.state.filters.filter_value
            )
        }
    }

    setSearch = (value) => {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
                search: value,
            },
        }))
    }

    setOrder = (by, asc) => {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
                sort: by,
                asc: asc,
            },
        }))
    }

    setFilter = (by, value) => {
        this.setState((prevState) => ({
            filters: {
                ...prevState.filters,
                filter_by: by,
                filter_value: value,
            },
        }))
    }

    render() {
        const renderHeader = () => {
            return (
                <>
                    <div className="search-bar-container mb-4">
                        <h5 className="icon text-secondary ">
                            <FontAwesomeIcon icon="search" />
                        </h5>
                        <input
                            className="form-control"
                            type="text"
                            placeholder="Search for ideas..."
                            onChange={(e) =>
                                this.setSearch(e.target.value)
                            }></input>
                    </div>

                    <div className="container row mb-2">
                        {/* <p className="font-weight-bold text-secondary mr-2">
                            Filter
                        </p> */}
                        {/* 
                        <div class="btn-group">
                            <div className="dropdown mr-2">
                                <button
                                    className={`btn ${
                                        this.state.filters.status
                                            ? 'btn-primary'
                                            : 'btn-light'
                                    } btn-sm dropdown-toggle`}
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {this.state.filters.status || 'Status'}
                                </button>
                                {this.state.filters.status && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() =>
                                            this.setFiltersProp(
                                                'status',
                                                undefined
                                            )
                                        }>
                                        x
                                    </button>
                                )}

                                <div
                                    className="dropdown-menu mr-2"
                                    aria-labelledby="dropdownMenu2">
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFiltersProp(
                                                'status',
                                                'Open'
                                            )
                                        }>
                                        Open
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFiltersProp(
                                                'status',
                                                'Accepted'
                                            )
                                        }>
                                        Accepted
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFiltersProp(
                                                'status',
                                                'Rejected'
                                            )
                                        }>
                                        Rejected
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFiltersProp(
                                                'status',
                                                'Implemented'
                                            )
                                        }>
                                        Implemented
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="btn-group">
                            <div className="dropdown mr-2">
                                <button
                                    className={`btn ${
                                        this.state.filters.tag
                                            ? 'btn-primary'
                                            : 'btn-light'
                                    } btn-sm dropdown-toggle`}
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {this.state.filters.tag || 'Tag'}
                                </button>
                                {this.state.filters.tag && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() =>
                                            this.setFiltersProp(
                                                'tag',
                                                undefined
                                            )
                                        }>
                                        x
                                    </button>
                                )}
                                <div
                                    className="dropdown-menu mr-2"
                                    aria-labelledby="dropdownMenu2">
                                    {this.props.tagList &&
                                        this.props.tagList.map((t) => (
                                            <button
                                                key={t.name}
                                                className="dropdown-item"
                                                type="button"
                                                onClick={() =>
                                                    this.setFiltersProp(
                                                        'tag',
                                                        t.name
                                                    )
                                                }>
                                                {t.name}
                                            </button>
                                        ))}
                                </div>
                            </div>
                        </div> */}
                        {/* 
                        <div class="btn-group">
                            <div className="dropdown mr-2">
                                <button
                                    className={`btn ${
                                        this.state.filters.filter_by ===
                                        'status'
                                            ? 'btn-primary'
                                            : 'btn-light'
                                    } btn-sm dropdown-toggle`}
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {this.state.filters.filter_by === 'status'
                                        ? this.state.filters.filter_value
                                        : 'Status'}
                                </button>
                                {this.state.filters.filter_by === 'status' && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() =>
                                            this.setFilter(undefined, undefined)
                                        }>
                                        x
                                    </button>
                                )}

                                <div
                                    className="dropdown-menu mr-2"
                                    aria-labelledby="dropdownMenu2">
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFilter('status', 'Open')
                                        }>
                                        Open
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFilter('status', 'Accepted')
                                        }>
                                        Accepted
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFilter('status', 'Rejected')
                                        }>
                                        Rejected
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        type="button"
                                        onClick={() =>
                                            this.setFilter(
                                                'status',
                                                'Implemented'
                                            )
                                        }>
                                        Implemented
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="btn-group">
                            <div className="dropdown mr-2">
                                <button
                                    className={`btn ${
                                        this.state.filters.filter_by === 'tag'
                                            ? 'btn-primary'
                                            : 'btn-light'
                                    } btn-sm dropdown-toggle`}
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    {this.state.filters.filter_by === 'tag'
                                        ? this.state.filters.filter_value
                                        : 'Tag'}
                                </button>
                                {this.state.filters.filter_by === 'tag' && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={() =>
                                            this.setFilter(undefined, undefined)
                                        }>
                                        x
                                    </button>
                                )}
                                <div
                                    className="dropdown-menu mr-2"
                                    aria-labelledby="dropdownMenu2">
                                    {this.props.tagList &&
                                        this.props.tagList.map((t) => (
                                            <button
                                                key={t.name}
                                                className="dropdown-item"
                                                type="button"
                                                onClick={() =>
                                                    this.setFilter(
                                                        'tag',
                                                        t.name
                                                    )
                                                }>
                                                {t.name}
                                            </button>
                                        ))}
                                </div>
                            </div>
                        </div> */}

                        <p className="font-weight-bold text-secondary ml-4 mr-2">
                            Order
                        </p>

                        <div className="dropdown mr-2">
                            <button
                                className="btn btn-light btn-sm dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                Date
                            </button>
                            <div
                                className="dropdown-menu mr-2"
                                aria-labelledby="dropdownMenu2">
                                <button
                                    className="dropdown-item"
                                    type="button"
                                    onClick={() =>
                                        this.setOrder('submitted_at', false)
                                    }>
                                    Newest
                                </button>
                                <button
                                    className="dropdown-item"
                                    type="button"
                                    onClick={() =>
                                        this.setOrder('submitted_at', true)
                                    }>
                                    Oldest
                                </button>
                            </div>
                        </div>
                        {/* 
                        <div className="dropdown mr-2">
                            <button
                                className="btn btn-light btn-sm dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                Votes
                            </button>
                            <div
                                className="dropdown-menu mr-2"
                                aria-labelledby="dropdownMenu2">
                                <button className="dropdown-item" type="button" onClick={() => {
                                        this.setFiltersProp('sort', 'submitted_at')
                                        this.setFiltersProp('asc', true)
                                    }}>
                                    Most Voted
                                </button>
                                <button className="dropdown-item" type="button">
                                    Least Voted
                                </button>
                            </div>
                        </div>

                        <div className="dropdown mr-2">
                            <button
                                className="btn btn-light btn-sm dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                Comments
                            </button>
                            <div
                                className="dropdown-menu mr-2"
                                aria-labelledby="dropdownMenu2">
                                <button className="dropdown-item" type="button">
                                    Most Comments
                                </button>
                                <button className="dropdown-item" type="button">
                                    Least Comments
                                </button>
                            </div>
                        </div> */}
                    </div>
                </>
            )
        }

        const renderIdeas = () => {
            if (!this.props.ideaList) return <Loading />

            if (this.props.ideaList.length === 0) return (
                <>
                    <h4 className="text-secondary text-center mt-4">No ideas submitted yet. <Link to="/submit">Why not be the first? </Link></h4>
                </>
            )
            

            return this.props.ideaList.map((idea) => (
                <div key={idea._id}>
                    {isIdeaWellFormed(idea) && (
                        <div
                            
                            style={{
                                opacity:
                                    idea.visibility_status === 'hidden'
                                        ? '.7'
                                        : 1,
                                MozOpacity: idea.visibility_status === 'hidden'
                                        ? '.7'
                                        : 1,
                                borderLeft:
                                    idea.visibility_status === 'hidden'
                                        ? 'var(--light-pink) dashed 2px '
                                        : 'none',
                            }}>
                            <div
                                key={idea._id}
                                className="py-2 idea-explorer-row">
                                <IdeaSummaryCard
                                    id="idea-explorer-navigation-content"
                                    idea={idea}
                                    redirectMode={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            ))
        }

        return (
            <>
                {(this.props.ideaList && this.props.ideaList.length > 0) && renderHeader()}
                {renderIdeas()}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    ideaList: state.ideas.ideaList,
    tagList: state.tags.availableTagsList,
})

export default connect(mapStateToProps, { getAvailableTagsList, fetchIdeas })(
    IdeaExplorerView
)
